<div class="tab-pane fade show active" id="day1" role="tabpanel" aria-labelledby="home-tab">
  <FlashMessage></FlashMessage>
  <div class="container-fluid">
    <div class="content-block">
      <div class="error-list" v-if="ui.error.errors">
        <ul class="error-msg">
          <li v-for="(error,x) in ui.error.errors" :key="x">
            <div v-for="(err,i) in error" :key="i">
              <p> {{err}}</p>
            </div>
          </li>
        </ul>
      </div>
      <form>
        <div class="form-modified">
          <div class="row">
            <div class="col-lg-10 offset-2">
              <div class="informative-block">
                <p>
                  You can add, edit, or delete the generic information of the package such as the title, destination,
                  altitude, and difficulty, etc.
                 
                </p>
                <span @click="hideIcon">×</span>
              </div>
            </div>
          </div>
          
          <div class="form-group row">
            <label for="staticEmail" class="col-sm-2 col-form-label">Enter Title <span class="required">*</span></label>
            <div class="col-sm-10">
              <div v-if="!status.Edit">
                <label v-if="item.generalList.title" for="staticEmail" class="readonly">{{item.generalList.title}}</label>
              </div>
              <div v-if="status.Edit">
                <input type="text" v-if="item.generalList.title" class="form-control"
                  :class="{ 'error-input' : ui.error.validationErrors['title'] }" id="inputPassword" v-model="item.generalList.title"
                  placeholder="Destination name" />
              </div>
              <validation-error v-if="ui.error.hasError" :isError="ui.error.hasError" :errors="ui.error.validationErrors" :field="'title'" />
            </div>
          </div>

          <div class="form-group row">
            <label for="inputPassword" class="col-sm-2 col-form-label">Destination <span
                class="required">*</span></label>
            <div class="col-sm-10">
              <label v-if="!status.Edit" for="staticEmail" class="readonly"><span
                  v-if="item.generalList.destination">{{item.generalList.destination.name}}</span></label>
              <div class="multiselect-input" v-if="item.destinationMaster">
                <multiselect v-if="status.Edit" :options='item.destinationMaster' v-model="item.generalList.destination"
                  label="name" :track-by="'name'" placeholder="Choose Tour Type.."
                  :class="{ 'error-input' : ui.error.validationErrors['destination_id'] }"></multiselect>
                <validation-error v-if="ui.error.hasError" :isError="ui.error.hasError" :errors="ui.error.validationErrors"
                  :field="'destination_id'" />
              </div>

            </div>
          </div>

          <div class="form-group row">
            <label for="staticEmail" class="col-sm-2 col-form-label">Enter description <span
                class="required">*</span></label>
            <div class="col-sm-10">
              <label v-if="!status.Edit" for="staticEmail" class="readonly">{{item.generalList.description}}</label>
              <textarea v-if="status.Edit" name="editor" cols="30" rows="4" class="form-control"
                :class="{ 'error-input' : ui.error.validationErrors['description'] }"
                v-model="item.generalList.description"></textarea>
              <validation-error v-if="ui.error.hasError" :isError="ui.error.hasError" :errors="ui.error.validationErrors" :field="'description'" />
            </div>
          </div>
          <div class="form-group row">
            <label for="inputPassword" class="col-sm-2 col-form-label">Teaser title <span class="required">*</span>
            </label>
            <div class="col-sm-10">
              <label v-if="!status.Edit" for="staticEmail" class="readonly">{{item.generalList.teaser_title}}</label>
              <input v-if="status.Edit" type="text" class="form-control"
                :class="{ 'error-input' : ui.error.validationErrors['teaser_title'] }" id="inputPassword"
                placeholder="Enter teaser title" v-model="item.generalList.teaser_title" />
              <validation-error v-if="ui.error.hasError" :isError="ui.error.hasError" :errors="ui.error.validationErrors" :field="'teaser_title'" />
            </div>
          </div>
          <div class="form-group row">
            <div class="col-lg-6">
              <div class="row">
                <label for="inputPassword" class="col-sm-4 col-form-label">Price
                  basis <span class="required">*</span></label>
                <div class="col-sm-8">
                  <label v-if="!status.Edit" for="staticEmail" class="readonly"><span
                      v-if="item.generalList.pricing_basis">{{item.generalList.pricing_basis.name}}</span></label>
                  <div class="multiselect-input" v-if="status.Edit">
                    <multiselect :options='getPricingBasis' v-model="item.generalList.pricing_basis" label="name"
                      :track-by="'name'" placeholder="Choose Pricing Basis.."
                      :class="{ 'error-input' : ui.error.validationErrors['pricing_basis_id'] }"></multiselect>
                    <validation-error v-if="ui.error.hasError" :isError="ui.error.hasError" :errors="ui.error.validationErrors"
                      :field="'pricing_basis_id'" />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="row">
                <label for="inputPassword" class="col-sm-4 col-form-label">Price ($ USD)<span class="required">*</span>
                </label>
                <div class="col-sm-8">
                  <label v-if="!status.Edit" for="staticEmail" class="readonly">{{item.generalList.base_price}}</label>
                  <input v-if="status.Edit" type="text" @keypress="preventNonNumericalInput($event)"
                    oninput="validity.valid||(value='');" class="form-control" id="inputPassword" placeholder="eg. 1400"
                    v-model="item.generalList.base_price" :class="{ 'error-input' : ui.error.validationErrors['base_price'] }" />
                  <validation-error v-if="ui.error.hasError" :isError="ui.error.hasError" :errors="ui.error.validationErrors"
                    :field="'base_price'" />
                </div>
              </div>
            </div>

          </div>


          <div class="form-group row">
            <div class="col-lg-6">
              <div class="row">
                <label for="inputPassword" class="col-sm-4 col-form-label">Tour type <span
                    class="required">*</span></label>
                <div class="col-sm-8">
                  <label v-if="!status.Edit" for="staticEmail" class="readonly"><span
                      v-if="item.generalList.tour_type">{{item.generalList.tour_type.name}}</span></label>
                  <div class="multiselect-input" v-if="getTourTypeList">
                    <multiselect v-if="status.Edit" :options='getTourTypeList' v-model="item.generalList.tour_type"
                      label="name" :track-by="'id'" placeholder="Choose Tour Type.."
                      :class="{ 'error-input' : ui.error.validationErrors['tour_type_id'] }"></multiselect>
                    <validation-error v-if="ui.error.hasError" :isError="ui.error.hasError" :errors="ui.error.validationErrors"
                      :field="'tour_type_id'" />
                  </div>

                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="row">
                <label for="inputPassword" class="col-sm-4 col-form-label">Difficulty level <span
                    class="required">*</span></label>
                <div class="col-sm-8">

                  <label v-if="!status.Edit" for="staticEmail" class="readonly"><span
                      v-if="item.generalList.difficulty_level">{{item.generalList.difficulty_level.name}}</span></label>


                  <div class="multiselect-input" v-if="getDifficultyLevelList">
                    <multiselect v-if="status.Edit" :options='getDifficultyLevelList'
                      v-model="item.generalList.difficulty_level" label="name" :track-by="'id'"
                      placeholder="Choose Difficulty Level.."
                      :class="{ 'error-input' : ui.error.validationErrors['difficulty_level_id'] }"></multiselect>
                    <validation-error v-if="ui.error.hasError" :isError="ui.error.hasError" :errors="ui.error.validationErrors"
                      :field="'difficulty_level_id'" />
                  </div>
                </div>
              </div>
            </div>

          </div>



          <div class="form-group row">
            <label for="inputPassword" class="col-sm-2 col-form-label">Altitude</label>
            <div class="col-sm-5">
              <label v-if="!status.Edit" for="staticEmail" class="readonly position-relative">
                {{item.generalList.altitude_in_meter}}
                <div class="input-group-append">
                  <span class="input-group-text" id="basic-addon1">meter</span>
                </div>
              </label>
              <div class="input-group" v-if="status.Edit">
                <input type="text" @keypress="preventNonNumericalInput($event)" oninput="validity.valid||(value='');"
                  v-if="status.Edit" class="form-control" id="inputPassword" placeholder="Altitude in meter"
                  v-model="item.generalList.altitude_in_meter" @keyup="ConvertToFeet" />
                <div class="input-group-append">
                  <span class="input-group-text" id="basic-addon1">meter</span>
                </div>
              </div>
            </div>
            <div class="col-sm-5">
              <label v-if="!status.Edit" for="staticEmail" class="readonly position-relative">
                {{item.generalList.altitude_in_feet}}
                <div class="input-group-append">
                  <span class="input-group-text" id="basic-addon1">feet</span>
                </div>
              </label>
              <div class="input-group" v-if="status.Edit">
                <input type="text" @keypress="preventNonNumericalInput($event)" oninput="validity.valid||(value='');"
                  class="form-control" id="inputPassword" placeholder="Altitude in feet"
                  v-model="item.generalList.altitude_in_feet" @keyup="ConvertToMeter" />
                <div class="input-group-append">
                  <span class="input-group-text" id="basic-addon1">feet</span>
                </div>
              </div>
            </div>
          </div>


          <div class="content-block">
            <div class="row">
              <div class="col-md-10 offset-md-2">
                <button v-if="status.Edit" :disabled="ui.status.postLoading.generalList" class="btn default-btn save-btn" type="submit"
                  @click.prevent="setGeneral">
                  {{buttonName}}
                  <spinner v-if="ui.PostLoading" :loading="ui.PostLoading"></spinner>
                </button>
                <button v-if="status.Edit" class="btn default-btn cancel" type="submit"
                  @click.prevent="cancelGeneralEdit">
                  Cancel
                </button>
                <button v-if="!status.Edit" class="btn default-btn" type="submit" @click.prevent="editGeneral">
                  Edit
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>